/**
 * Positions a currency symbol around pre-formatted amount text.
 */

import { formatCurrencySample, getCurrencyFormattingContext } from './currency-intl.js';

/** @deprecated Legacy prefix locales used by web4 compact amount formatting. */
const PREFIX_LOCALES = new Set(['en-US', 'en-GB', 'th-TH']);

const resolveSymbol = (currencySymbol, defaultUserCurrencySymbol) => {
    return currencySymbol || defaultUserCurrencySymbol || '€';
};

/**
 * @param {string} text
 * @param {string} [currencySymbol]
 * @param {string} [currencyCode='EUR']
 * @param {string} [locale]
 * @returns {string|undefined}
 */
export const positionCurrencySymbolAroundText = (
    text,
    currencySymbol = '',
    currencyCode = 'EUR',
    locale,
) => {
    if (!text && text !== '') return;

    const { defaultUserCurrencySymbol } = getCurrencyFormattingContext();
    const resolvedLocale = locale ?? getCurrencyFormattingContext().locale;
    let sample = formatCurrencySample(currencyCode, resolvedLocale);
    let symbol = resolveSymbol(currencySymbol, defaultUserCurrencySymbol);

    if (symbol && symbol !== '€') {
        sample = sample.replace('€', symbol);
    }

    if (sample.indexOf(symbol) === 0) {
        return `${symbol} ${text}`;
    }

    if (sample.length > 1 && /\s/.test(sample[sample.length - 2])) {
        symbol = ` ${symbol}`;
    }

    return `${text}${symbol}`;
};

/**
 * Legacy-compatible helper for compact amount strings (web4 amount util).
 * Keeps the historical prefix list instead of Intl sampling so locales like
 * pt-BR and ja-JP remain suffix-formatted as before.
 *
 * @param {string} amount
 * @param {string} currencySymbol
 * @param {string} locale
 * @returns {string}
 */
export const appendCurrencySymbolByLocale = (amount, currencySymbol, locale) => {
    if (!currencySymbol) return amount;

    if (PREFIX_LOCALES.has(locale)) {
        return `${currencySymbol} ${amount}`;
    }

    return `${amount} ${currencySymbol}`;
};
